export const dataText = [
  {
    en: {
      title: 'ATTENTION',
      text: 'The user could not register, please contact support',
      buttonTitle: "CLOSE"
    },
    es: {
      title: 'ATENCION',
      text: 'El usuario no logro registrarse que por favor contacte con soporte',
      buttonTitle: "CERRAR"
    },
    pt: {
      title: 'ATENÇÃO',
      text: 'O usuário não pôde se registrar, entre em contato com o suporte',
      buttonTitle: "FECHAR"
    }
  },
  {
    en: {
      title: 'ATTENTION',
      text: 'Lottery is not available for your country',
      buttonTitle: "CLOSE"
    },
    es: {
      title: 'ATENCION',
      text: 'Loteria no esta disponible para su pais',
      buttonTitle: "CERRAR"
    },
    pt: {
      title: 'ATENÇÃO',
      text: 'A loteria não está disponível para o seu país',
      buttonTitle: "FECHAR"
    }
  }
];
